import { get, post } from './commonFetch';

import { Waiver } from '../types/waiver';

import { API_ROUTES } from '../constants';

export function getWaivers(): Promise<Waiver[]> {
  return get(API_ROUTES.waivers);
}

export function updateChangeEventId(waiver: Waiver, changeEventId: number): Promise<any> {
  const oldChangeEventId = waiver.changeEventId;
  const waiverId = waiver.id;
  const url = API_ROUTES.waiverUpdateChangeEventId.replace(
    /:id/,
    changeEventId.toString(),
  );
  return post(url, { waiverId, oldChangeEventId });
}
